import { browser } from '$app/environment';

export function getEnv() {
	if (!browser) {
		return {};
	}
	return window.environmentSettings;
}
